import styles from "./Projects.module.scss";
import { Link } from "react-router-dom";
import data from "./data";

const Projects = () => {
  return (
    <section className={styles.projects}>
      <h2>React Projects</h2>
      <div className={styles.articles}>
        {data.map((project) => (
          <div className={styles.article}>
            <div className={styles.heading}>
              <Link to={project.link} className={styles.goto} target="_blank">
                <h3>{project.projectName}</h3>
              </Link>
              <span>{project.projectInfo}</span>
            </div>
            <p className={styles.description}>
              {project.description_a}
              <br />
              <br />
              <p className={styles.description_b}>{project.description_b}</p>
            </p>
            <small>
              <a href={project.repo}>Github Repo</a>
            </small>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
